import React from 'react';
import styled from 'styled-components';

import { useCardContext } from './card-context';
import { CollectionBadge } from './components/collection-card-badge';
import { SpecialOfferRotator } from './components/special-offer-rotator';

/** Special offer rotator and collection badge. Renders nothing when neither is present. */
export function CardTags(): JSX.Element | null {
  const { isSpecialOffer, specialNames, hideSalesLanguage, collectionBadge } = useCardContext();

  if (!isSpecialOffer && !collectionBadge) {
    return null;
  }

  return (
    <Tags>
      {isSpecialOffer && <SpecialOfferRotator specialNames={specialNames} hideSalesLanguage={hideSalesLanguage} />}
      {collectionBadge && <CollectionBadge {...collectionBadge} />}
    </Tags>
  );
}

const Tags = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  font-weight: 500;
  gap: 4px;
  line-height: ${13 / 12};
  margin-top: 16px;
  text-transform: ${({ theme }) => theme.customized.textTransforms.tags};
`;
